"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/01/31
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPort = set;
exports.getPort = getPort;
exports.setPortListener = setListener;
exports.sendMessage = sendMessage;
let retryCount = 0;
let lastRetry = 0;
let port;
const storage = {
    messages: [],
    listener: () => {
        /* noop */
    },
};
function set(newPort) {
    port = newPort;
}
function getPort() {
    return port;
}
function retry() {
    if (port) {
        retryCount = 0;
        if (typeof storage.listener === "function") {
            setListener(storage.listener);
            storage.listener = undefined;
        }
        while (storage.messages.length > 0) {
            const msg = storage.messages.shift();
            sendMessage(msg);
        }
    }
    else {
        const now = Date.now();
        if (lastRetry === 0 || now - 900 > lastRetry) {
            lastRetry = now;
            retryCount += 1;
            if (retryCount < 7) {
                setTimeout(retry, 1000);
            }
            else {
                throw new Error("[partner-comm] retrying setup failed");
            }
        }
    }
}
function setListener(onMessage) {
    if (port) {
        port.onmessage = (evt) => {
            const { type, message } = evt.data;
            onMessage({ type, message });
        };
    }
    else {
        storage.listener = onMessage;
        setTimeout(retry, 1000);
    }
}
function sendMessage(data) {
    if (port) {
        retry();
        port.postMessage(data);
    }
    else {
        storage.messages.push(data);
        setTimeout(retry, 1000);
    }
}
//# sourceMappingURL=port.js.map